import { toast } from 'sonner';

export const useHandleToast = () => {
  const showToast = (message: string) => {
    toast.message(message, {
      position: 'top-right',
      style: {
        fontSize: '20px',
      },
    });
  };
  const showSuccessToast = (message: string) => {
    toast.message(message, {
      position: 'top-right',
      style: {
        fontSize: '20px',
        color: '#26AA68',
      },
    });
  };
  const showErrorToast = (message?: string) => {
    toast.message(message ?? 'Something went wrong. Please try again.', {
      position: 'top-right',
      style: {
        fontSize: '20px',
        color: 'red',
      },
    });
  };
  return { showToast, showSuccessToast, showErrorToast };
};
